<template>
  <div>
    <el-upload class="upload" :class="{hide: disabled}" :disabled="disabled" :headers="headers" :action="action"
      :on-preview="handlePreview" :on-success="handleAvatarSuccess" :on-remove="handleRemove"
      :before-remove="beforeRemove" :multiple="multiple" :limit="limit" :on-exceed="handleExceed"
      :file-list="showFileList ? fileList : []">
      <el-button v-if="!disabled" size="small" type="primary">点击上传</el-button>
    </el-upload>
  </div>
</template>

<script>
import { API_CONFIG } from '@/page/config/base_config'
import _ from 'lodash'
import { getToken } from '@/framework/util/auth'
export default {
  props: ['column', 'scope'],
  data() {
    const {
      action,
      headers,
      multiple,
      limit,
      disabled,
      showFileList
    } = this.column
    return {
      disabled,
      fileList: [],
      headers: Object.assign(headers || {}, getToken()),
      action,
      limit,
      multiple,
      showFileList
    }
  },
  watch: {
    fileList(v) {
      this.$emit('on-edit', v, this.column.prop, this.scope.$index)
    }
    // scope({ row }) {
    //   this.fileList = row[this.column.prop]
    // }
  },
  mounted() {
    this.fileList = this.scope.row[this.column.prop] || []
  },
  methods: {
    handlePreview(file) {
      const {
        fileContentType,
        fileUniqueCode,
        value
      } = file

      const url = `${API_CONFIG.FDFS_WEB_SERVER_URL}${value}`

      if (fileContentType.startsWith('image/')) {
        return this.$ImagePreview([{ url, thumbUrl: url }], 0)
      }

      if (fileContentType === 'application/pdf') {
        window.open(file.url, '_blank')
      } else {
        this.$downloadFile.get('/common/document/download', {
          params: {
            fileName: file.name,
            fileUniqueCode,
            doDownload: true
          }
        }).then(_ => { }).catch(error => {
          this.$alert(`加载文件失败..${error.msg || error.message}`, '错误', {
            confirmButtonText: '确定',
            type: 'error'
          })
        })
      }
    },
    handleAvatarSuccess({ data }, file) {
      const {
        fileUniqueCode,
        fileName,
        fastDFSGroupName,
        fastDFSPath,
        fileSize,
        fileContentType,
        fastDFSThumbImagePath
      } = data
      const index = _.findIndex(this.fileList, { fileUniqueCode })

      let row = {
        ...file,
        fileUniqueCode,
        label: fileName,
        value: `/${fastDFSGroupName}/${fastDFSPath}`,
        fileSize,
        fileContentType,
        fastDFSThumbImagePath: fileContentType.startsWith('image/') ? `/${fastDFSGroupName}/${fastDFSThumbImagePath}` : null
      }
      if (index >= 0) {
        row = {
          ...this.fileList[index],
          ...row
        }
        this.fileList.splice(index, 1, row)
      } else {
        this.fileList.push(row)
      }
    }

  }
}
</script>

<style lang="scss" scoped>
:deep(.hide .el-upload) {
  display: none !important;
}
</style>
